import { useMemo } from "react"

function useOptions(param: object): string[] {
    const options = useMemo(() => Object.values(param), [param])

    return options
}

export default useOptions
